export default __webpack_public_path__ + "static/404-man-0850c120898836f9268e4412f82c9775.svg";